<template>
  <div v-if="show" class="fixed z-[10000] inset-0 overflow-y-auto">
    <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-900/60 backdrop-blur-md"></div>
      </div>

      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

      <div class="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:align-middle sm:w-full sm:max-w-md border border-gray-100">
        <div class="px-8 pt-8 pb-4">
          <div class="text-center">
            <div class="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-blue-50 mb-4">
              <i class="material-icons text-3xl text-[#0d47a1]">verified_user</i>
            </div>
            <h3 class="text-2xl font-bold text-[#0d47a1]" id="modal-title">
              Verify Your Account
            </h3>
            <p class="text-gray-500 mt-2">
              We've sent a verification code to your email. Please enter it below to continue.
            </p>
          </div>
        </div>
        
        <div class="px-8 py-4">
          <div class="space-y-4">
            <div v-if="error" class="bg-red-50 border border-red-200 text-red-600 text-sm px-4 py-2 rounded">
              {{ error_msg }}
            </div>
            <div v-if="success" class="bg-green-50 border border-green-200 text-green-600 text-sm px-4 py-2 rounded">
              {{ success_msg }}
            </div>

            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-1" for="otp">OTP Code</label>
              <input 
                id="otp"
                v-model="otp_code" 
                type="text" 
                maxlength="6"
                class="w-full text-center text-2xl tracking-widest px-4 py-3 border border-gray-300 rounded-xl outline-none focus:ring-2 focus:ring-[#0d47a1] focus:border-transparent transition"
                placeholder="000000"
                @keyup.enter="verifyOtp"
              >
            </div>

            <div class="text-center">
              <button 
                @click="resendOtp" 
                :disabled="resending"
                class="text-sm font-medium text-[#0d47a1] hover:text-blue-800 disabled:text-gray-400 transition-colors"
              >
                {{ resending ? 'Sending...' : "Didn't receive code? Resend" }}
              </button>
            </div>
          </div>
        </div>

        <div class="px-8 py-8 flex flex-col space-y-3">
          <button 
            type="button" 
            :disabled="loading || otp_code.length < 4"
            class="w-full inline-flex justify-center rounded-xl border border-transparent shadow-lg px-8 py-3 bg-[#0d47a1] text-base font-bold text-white hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all disabled:bg-gray-300 disabled:shadow-none" 
            @click="verifyOtp"
          >
            {{ loading ? 'Verifying...' : 'Verify & Continue' }}
          </button>
          <button 
            @click="logout"
            class="w-full text-sm text-gray-500 hover:text-gray-700 font-medium"
          >
            Log out
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import get_api from '../service/api.js'
import base_url from '../service/base_url.js'

export default {
  name: 'OTPVerificationModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      otp_code: '',
      loading: false,
      resending: false,
      error: false,
      error_msg: '',
      success: false,
      success_msg: ''
    }
  },
  created() {
    this.api = get_api(this.$router)
  },
  methods: {
    verifyOtp() {
      if (this.otp_code.length < 4) return
      
      this.loading = true
      this.error = false
      this.success = false

      this.api.post(`${base_url}/verify-otp`, {
        otp_code: this.otp_code
      }).then(() => {
        this.success = true
        this.success_msg = 'Verification successful!'
        setTimeout(() => {
          this.$emit('verified')
          this.loading = false
        }, 1500)
      }).catch((err) => {
        this.loading = false
        this.error = true
        this.error_msg = err.response?.data?.message || 'Invalid OTP code. Please try again.'
      })
    },
    resendOtp() {
      this.resending = true
      this.error = false
      this.success = false

      this.api.get(`${base_url}/resend-otp-verification`)
        .then(() => {
          this.resending = false
          this.success = true
          this.success_msg = 'A new verification code has been sent to your email.'
        })
        .catch((err) => {
          this.resending = false
          this.error = true
          this.error_msg = err.response?.data?.message || 'Failed to resend OTP. Please try again later.'
        })
    },
    logout() {
      localStorage.removeItem('XPAYROLLaccess_token')
      window.location.reload()
    }
  }
}
</script>
